module.exports = __webpack_public_path__ + "static/media/Iconfield07.ccbf6b6d.svg";